/** Public fairness record (`/draws/:drawId/fairness`): commitment, hashes, bundle download, verifier (outcome agent, §9.1, §9.4). */
import type { RouteObject } from 'react-router';
import { lazyRoute } from '../lazy';

const FairnessPage = lazyRoute(() => import('./FairnessPage'), 'page');

export const fairnessRoutes: RouteObject[] = [{ path: '/draws/:drawId/fairness', element: <FairnessPage /> }];
